import KybRfiSummary from 'modules/merchantinfo/components/KybRfiSummary';

function KybRfi() {
  return <KybRfiSummary />;
}

export default KybRfi;
